import SimpleTextPage from "../components/SimpleTextPage";

function Feedback() {
  return (
    <div style={{ marginInline: "5%", paddingTop: "270px", minHeight: "80vh" }}>
      <SimpleTextPage pageId="2ac78aef-ac6b-46be-8ad3-a10362e7aacb" />
    </div>
  );
}

export default Feedback;
